module.exports = __webpack_public_path__ + "img/logo_taxert.0c746849.png";